<template>

    <AppHead title="Veranstalter-Login" />

    <div class="lg:px-64">
        <PageTitle>Veranstalter-Login</PageTitle>

        <div class="w-full lg:flex items-start lg:space-x-8 mt-4">

            <div class="w-full lg:w-1/2">

                <p class="mb-4">
                    Sie haben sich bereits als Veranstalter registriert?<br>
                    Dann nutzen Sie bitte Ihren Veranstalter-Login.
                </p>

                <FormValidationErrors class="mb-4" />

                <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
                    {{ status }}
                </div>

                <form @submit.prevent="submit">
                    <div>
                        <FormLabel for="email" value="Benutzername: Ihre E-Mail-Adresse" />
                        <FormInput id="email" type="email" class="mt-1 block w-full" v-model="form.email" required autofocus autocomplete="username" />
                    </div>

                    <div class="mt-4">
                        <FormLabel for="password" value="Passwort" />
                        <FormInput id="password" type="password" class="mt-1 block w-full" v-model="form.password" required autocomplete="current-password" />
                    </div>

                    <div class="block mt-4">
                        <label class="flex items-center">
                            <FormCheckbox type="checkbox" name="remember" v-model:checked="form.remember" />
                            <span class="ml-2 text-sm text-gray-600">An mich erinnern</span>
                        </label>
                    </div>

                    <div class="flex items-center justify-end mt-4">
                        <Link v-if="canResetPassword" href="/manager/forgot-password">
                            Passwort vergessen?
                        </Link>

                        <FormButton class="ml-4" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                            Anmelden
                        </FormButton>
                    </div>
                </form>

            </div>

            <div class="w-full lg:w-1/2 mt-4 lg:mt-0">
                <p>
                    Sie sind neu hier?<br>
                    Dann registrieren Sie sich einmalig kostenlos als Veranstalter*,
                    um Ihre Veranstaltungen einzutragen
                </p>
                <Link href="/manager/register" as="button" class="p-2 my-2 bg-blue-500 hover:bg-blue-700 rounded-md text-white text-xs">
                    Registrieren
                </Link>
                <p class="text-xs">
                    * Veranstalter sind Beauftragte von Theatern, Bühnen, Clubs, Vereinen, Verbänden, Chören, Solo Selbständige und Künstler u.ä. im Sinne der Internetplattform.
                    <strong>KEINE</strong> Privatpersonen.
                </p>
            </div>

        </div>

    </div>

</template>

<script setup>
import { Link, useForm } from '@inertiajs/vue3';
import AppHead from '@/Shared/Head'
import PageTitle from '@/Shared/Page/Title'
import FormValidationErrors from '@/Shared/Form/ValidationErrors';
import FormLabel from '@/Shared/Form/Label';
import FormInput from '@/Shared/Form/Input';
import FormCheckbox from '@/Shared/Form/Checkbox';
import FormButton from '@/Shared/Form/Button';

defineProps({
    canResetPassword: Boolean,
    status: String,
});

const form = useForm({
    email: '',
    password: '',
    remember: false
});

const submit = () => {
    form.post('/manager/login', {
        onFinish: () => form.reset('password'),
    });
};
</script>
